module.exports = __webpack_public_path__ + "static/media/Gail the Construction Worker.f25b6e45.jpg";